var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('capa-header-vue',{attrs:{"id":"capaHeader"}}),_c('mobileHeader',{staticClass:"teste"}),_c('tutorial-header-vue'),_c('type-service-header',{attrs:{"id":"typeService"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }